import { Injectable } from '@angular/core';
import { VCF_5_2_1_STANDARD_MANAGEMENT } from './input-configs/VCF_5_2_1_STANDARD_MANAGEMENT';
import { VCF_5_2_1_STANDARD_WORKLOAD } from './input-configs/VCF_5_2_1_STANDARD_WORKLOAD';
import { VCF_9_0_0_STANDARD_MANAGEMENT } from './input-configs/VCF_9_0_0_STANDARD_MANAGEMENT';
import { VCF_9_0_0_STANDARD_WORKLOAD } from './input-configs/VCF_9_0_0_STANDARD_WORKLOAD';
import { VCF_9_1_0_STANDARD_MANAGEMENT } from './input-configs/VCF_9_1_0_STANDARD_MANAGEMENT';
import { VCF_9_1_0_STANDARD_WORKLOAD } from './input-configs/VCF_9_1_0_STANDARD_WORKLOAD';
import { VcfDomain } from 'pcs-domain';


export interface IWldInputProductConfig {
    configuration: VcfDomain.Group;
    getProductInfo(): string;
    getDatabaseConnectionString(): string;
    getApiEndpoint(): string;
    getDeploymentStrategy(): string;
}

@Injectable({
    providedIn: 'root' 
})
export class DomainInputConfigurationFactoryService { 

    constructor() { }

    public getConfiguration(
        product: string,
        version: string,
        architecture: string,
        domain: string
    ): IWldInputProductConfig | null {
        switch (product) {
            case "VCF":
                if (architecture.toUpperCase() === "STANDARD") {
                    if (domain === "MANAGEMENT") {
                        if (version === "9.1.0") {
                            return new VCF_9_1_0_STANDARD_MANAGEMENT();
                        }
                        if (version === "9.0.0") {
                            return new VCF_9_0_0_STANDARD_MANAGEMENT();
                        }
                        return new VCF_5_2_1_STANDARD_MANAGEMENT();
                    } else if (domain === "WORKLOAD") {
                        if (version === "9.1.0") {
                            return new VCF_9_1_0_STANDARD_WORKLOAD();
                        }
                        if (version === "9.0.0") {
                            return new VCF_9_0_0_STANDARD_WORKLOAD();
                        }
                        return new VCF_5_2_1_STANDARD_WORKLOAD();
                    }
                }
                break;
        }
        return null;
    }
}